<span class="tag-item px-2 py-1 d-inline-block col-auto">
	<ng-template
		#defaultTagItemTpl
		let-tagItem="tagItem"
	>
		<span>{{ tagItem?.value }}</span>
	</ng-template>

	<ng-template
		[ngTemplateOutlet]="tag?.enforceCustomTemplate ? tagItemTpl : defaultTagItemTpl"
		[ngTemplateOutletContext]="{ tagItem: tag }"
	></ng-template>
</span>
